
import _ from 'lodash';

const wifi = {};

function oldWifiScan(){
  return new Promise(function(resolve,reject){
    WifiWizard.setWifiEnabled(true,function(e){
      WifiWizard.startScan(function(e){console.log(e)},function(e){console.log(e)})
    },function(e){
      WifiWizard.startScan(function(e){console.log(e)},function(e){console.log(e)})
    })
    
    setTimeout(function(){
      WifiWizard.getScanResults(function(e){
        this.resolve(e)
      }.bind({resolve : this.resolve}),function(e){
        this.reject(e)
      }.bind({reject : this.reject}));
    }.bind({resolve,reject}),3000)
  })
}

function oldWifiSSID(){
  return new Promise(function(resolve,reject){
    WifiWizard.getCurrentSSID(function(SSID){
      this.resolve(SSID)
    }.bind({resolve}),function(e){
      this.reject(e)
    }.bind({reject}))
  })
}

wifi.list = async function () {
  // TODO   requestAccuracy()
  if(device.platform == "iOS") {

    return [await wifi.get()]

  }else if (device.platform.toLowerCase() == 'android' && parseInt( device.version, 10 ) <= 6){
   

    return oldWifiScan()

  }
  else{
  
    try{

      await WifiWizard2.requestPermission();
    }catch(e){
      console.log(e)
    }
    try{

      await WifiWizard2.enableWifi();
    } catch(e){
      console.log(e)
    }

    try{ 
  
    return WifiWizard2.scan();
    
    }catch(e){
      console.log(e)
    }

  }

};


wifi.get = async function () {

  if (device.platform.toLowerCase() == 'android' && parseInt( device.version, 10 ) <= 6){

    var networks = await oldWifiScan()
    console.log("Got networks"+ JSON.stringify(networks))
    var SSID = await oldWifiSSID()
    console.log("Got sssid " +SSID)
    SSID = _.replace(SSID, new RegExp('"', 'g'), '')
    var net = {}

    for(var x in networks) {
        if(networks[x].SSID.toString().trim().toLowerCase() == SSID.toString().trim().toLowerCase()){
          net= networks[x]
        }
    }

    console.log("NET LIST " +  JSON.stringify(net))

    console.log("Wifi is "+SSID + " BSSID " + net.BSSID)
  
  
  return {  SSID : SSID ,  BSSID :  _.replace(net.BSSID, new RegExp('"', 'g'), '')}

  }
  else{
    return { SSID: await _.replace(await WifiWizard2.getConnectedSSID(), new RegExp('"', 'g'), ''), BSSID: await _.replace(await WifiWizard2.getConnectedBSSID(), new RegExp('"', 'g'), '') };
  }
  
};


export default wifi
